export default "__VITE_PUBLIC_ASSET__e46ba4fb__"